var _defs, _circle, _path, _g, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojis05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#e9dcff;}.c{fill:#5a1372;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 500,
    cy: 500,
    r: 404
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M500,922.73c-57.06,0-112.42-11.18-164.55-33.23-50.34-21.29-95.55-51.77-134.36-90.59-38.82-38.82-69.29-84.02-90.59-134.36-22.05-52.13-33.23-107.49-33.23-164.55s11.18-112.42,33.23-164.55c21.29-50.34,51.77-95.55,90.59-134.36s84.02-69.29,134.36-90.59c52.13-22.05,107.49-33.23,164.55-33.23s112.42,11.18,164.55,33.23c50.34,21.29,95.55,51.77,134.36,90.59,38.82,38.82,69.29,84.02,90.59,134.36,22.05,52.13,33.23,107.49,33.23,164.55s-11.18,112.42-33.23,164.55c-21.29,50.34-51.77,95.55-90.59,134.36-38.82,38.82-84.02,69.29-134.36,90.59-52.13,22.05-107.49,33.23-164.55,33.23Zm0-808c-52.02,0-102.47,10.18-149.96,30.27-45.88,19.4-87.08,47.19-122.47,82.57-35.39,35.39-63.17,76.59-82.57,122.47-20.08,47.49-30.27,97.94-30.27,149.96s10.18,102.47,30.27,149.96c19.4,45.88,47.19,87.08,82.57,122.47,35.39,35.39,76.59,63.17,122.47,82.57,47.49,20.08,97.94,30.27,149.96,30.27s102.47-10.18,149.96-30.27c45.88-19.4,87.08-47.19,122.47-82.57s63.17-76.59,82.57-122.47c20.08-47.49,30.27-97.94,30.27-149.96s-10.18-102.47-30.27-149.96c-19.4-45.88-47.19-87.08-82.57-122.47-35.39-35.39-76.59-63.17-122.47-82.57-47.49-20.08-97.94-30.27-149.96-30.27Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 354.25,
    cy: 494,
    rx: 31.5,
    ry: 53
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M354.25,556.5c-22.99,0-41-27.45-41-62.5s18.01-62.5,41-62.5,41,27.45,41,62.5-18.01,62.5-41,62.5Zm0-106c-10.41,0-22,17.86-22,43.5s11.59,43.5,22,43.5,22-17.87,22-43.5-11.59-43.5-22-43.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 645.75,
    cy: 494,
    rx: 31.5,
    ry: 53
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M645.75,556.5c-22.99,0-41-27.45-41-62.5s18.01-62.5,41-62.5,41,27.45,41,62.5-18.01,62.5-41,62.5Zm0-106c-10.41,0-22,17.86-22,43.5s11.59,43.5,22,43.5,22-17.87,22-43.5-11.59-43.5-22-43.5Z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M587.5,732.23h-175c-10.35,0-18.73-8.39-18.73-18.73s8.39-18.73,18.73-18.73h175c10.35,0,18.73,8.39,18.73,18.73s-8.39,18.73-18.73,18.73Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M784.49,309.12c-1.2-15.6-40.07-65.62-80.99-65.62-15.52,0-31.13,8.94-44.12,16.51-17.11,9.97-33.22,21.63-48.85,33.76-12.72,9.87-28.23,19.94-37.53,33.23-7,10-5,23,19.37,13.4,16.22-6.39,79.47-46.37,88.93-51.42,23.02-12.29,26.41-4.66,38.13,5.07,4.44,3.69,9.98,8.28,17.52,12.75,23.97,14.2,35.97,18.08,42.82,13.82,2.44-1.52,5.24-4.74,4.72-11.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M410.72,353.4c-10.76,1.6-21.37,4.26-31.72,7.6-31,10-88-17-111-17s-63.68,31.45-57,43c11,19,28-8,54-6,30.97,2.38,54,17,91,17,17.97,0,36.45-6.07,52.46-13.86,7.61-3.7,33.83-16.17,25.11-28.91-3.58-5.23-17.65-2.6-22.86-1.82Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojis05);
export default __webpack_public_path__ + "static/media/Emojis-05.3a5b610b36905d3190b7d757e7a95338.svg";
export { ForwardRef as ReactComponent };